import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Admin} from '../admin';
import {AbstractControl, FormControl, FormGroup, Validators} from '@angular/forms';
import {ZahValidators} from '../../core/form/validators';

@Component({
    selector: 'zah-upsert-admin',
    templateUrl: './upsert-admin.component.html',
    styleUrls: ['./upsert-admin.component.scss'],
    standalone: false
})
export class UpsertAdminComponent implements OnInit {

  @Input()
  admin?: Admin;
  @Input()
  okLabel: string;
  @Output()
  cancelClicked: EventEmitter<void> = new EventEmitter<void>();
  @Output()
  okClicked: EventEmitter<Admin> = new EventEmitter<Admin>();

  upsertAdminForm: FormGroup;

  ngOnInit(): void {
    this.upsertAdminForm = new FormGroup({
      voornaam: new FormControl(this.admin?.getVoornaam(), ZahValidators.notBlank),
      achternaam: new FormControl(this.admin?.getAchternaam(), ZahValidators.notBlank),
      personeelsnummer: new FormControl(
        {value: this.admin?.getPersoneelsnummer(), disabled: !!this.admin},
        ZahValidators.notBlank),
      email: new FormControl(
        {value: this.admin?.getEmail(), disabled: !!this.admin},
        [ZahValidators.notBlank, Validators.email])
    });
  }

  onCancelClicked(): void {
    this.cancelClicked.emit();
  }

  onOkClicked(): void {
    this.okClicked.emit(new Admin(
      this.admin?.getId(),
      this.voornaam.value,
      this.achternaam.value,
      this.personeelsnummer.value,
      this.email.value,
      )
    );
  }

  get voornaam(): AbstractControl {
    return this.upsertAdminForm.controls.voornaam;
  }

  get achternaam(): AbstractControl {
    return this.upsertAdminForm.controls.achternaam;
  }
  get personeelsnummer(): AbstractControl {
    return this.upsertAdminForm.controls.personeelsnummer;
  }

  get email(): AbstractControl {
    return this.upsertAdminForm.controls.email;
  }
}
